/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as import0 from '../../../../app/core/inctruction.component/instruction.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/security';
import * as import6 from '@angular/core/src/metadata/view';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/constants';
import * as import9 from '@angular/core/src/linker/component_factory';
import * as import10 from './instruction.component.css.shim.ngstyle';
import * as import11 from '@angular/core/src/animation/animation_transition';
import * as import12 from '@angular/core/src/animation/animation_sequence_player';
import * as import13 from '@angular/core/src/animation/animation_styles';
import * as import14 from '@angular/core/src/animation/animation_style_util';
import * as import15 from '@angular/core/src/animation/animation_keyframe';
import * as import16 from '@angular/core/src/animation/animation_player';
var Wrapper_InstructionComponent = (function () {
    function Wrapper_InstructionComponent() {
        this._changed = false;
        this.context = new import0.InstructionComponent();
        this._expr_0 = import1.UNINITIALIZED;
        this._expr_1 = import1.UNINITIALIZED;
    }
    Wrapper_InstructionComponent.prototype.ngOnDetach = function (view, componentView, el) {
        var animationTransition_routeAnimationLeft = componentView.componentType.animations['routeAnimationLeft'](view, el, this._expr_0, 'void');
    };
    Wrapper_InstructionComponent.prototype.ngOnDestroy = function () {
    };
    Wrapper_InstructionComponent.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_InstructionComponent.prototype.checkHost = function (view, componentView, el, throwOnChange) {
        var currVal_0 = this.context.routeAnimationLeft;
        if (import3.checkBinding(throwOnChange, this._expr_0, currVal_0)) {
            var animationTransition_routeAnimationLeft = componentView.componentType.animations['routeAnimationLeft'](view, el, ((this._expr_0 == import1.UNINITIALIZED) ? 'void' : this._expr_0), ((currVal_0 == import1.UNINITIALIZED) ? 'void' : currVal_0));
            this._expr_0 = currVal_0;
        }
        var currVal_1 = this.context.position;
        if (import3.checkBinding(throwOnChange, this._expr_1, currVal_1)) {
            view.renderer.setElementStyle(el, 'position', ((view.viewUtils.sanitizer.sanitize(import4.SecurityContext.STYLE, currVal_1) == null) ? null : view.viewUtils.sanitizer.sanitize(import4.SecurityContext.STYLE, currVal_1).toString()));
            this._expr_1 = currVal_1;
        }
    };
    Wrapper_InstructionComponent.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_InstructionComponent.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_InstructionComponent;
}());
export { Wrapper_InstructionComponent };
var renderType_InstructionComponent_Host = import3.createRenderComponentType('', 0, import6.ViewEncapsulation.None, [], {});
var View_InstructionComponent_Host0 = (function (_super) {
    __extends(View_InstructionComponent_Host0, _super);
    function View_InstructionComponent_Host0(viewUtils, parentView, parentIndex, parentElement) {
        return _super.call(this, View_InstructionComponent_Host0, renderType_InstructionComponent_Host, import7.ViewType.HOST, viewUtils, parentView, parentIndex, parentElement, import8.ChangeDetectorStatus.CheckAlways) || this;
    }
    View_InstructionComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer, 'ng-component', import3.EMPTY_INLINE_ARRAY, rootSelector, null);
        this.compView_0 = new View_InstructionComponent0(this.viewUtils, this, 0, this._el_0);
        this._InstructionComponent_0_3 = new Wrapper_InstructionComponent();
        this.compView_0.create(this._InstructionComponent_0_3.context);
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), null);
        return new import9.ComponentRef_(0, this, this._el_0, this._InstructionComponent_0_3.context);
    };
    View_InstructionComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.InstructionComponent) && (0 === requestNodeIndex))) {
            return this._InstructionComponent_0_3.context;
        }
        return notFoundResult;
    };
    View_InstructionComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._InstructionComponent_0_3.ngDoCheck(this, this._el_0, throwOnChange);
        this._InstructionComponent_0_3.checkHost(this, this.compView_0, this._el_0, throwOnChange);
        this.compView_0.internalDetectChanges(throwOnChange);
    };
    View_InstructionComponent_Host0.prototype.destroyInternal = function () {
        this.compView_0.destroy();
    };
    View_InstructionComponent_Host0.prototype.detachInternal = function () {
        this._InstructionComponent_0_3.ngOnDetach(this, this.compView_0, this._el_0);
    };
    View_InstructionComponent_Host0.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    return View_InstructionComponent_Host0;
}(import2.AppView));
export var InstructionComponentNgFactory = new import9.ComponentFactory('ng-component', View_InstructionComponent_Host0, import0.InstructionComponent);
var styles_InstructionComponent = [import10.styles];
var InstructionComponent_routeAnimationLeft_states = {
    '*': {
        'opacity': '1',
        'transform': 'translateX(0)'
    },
    'void': {}
};
function InstructionComponent_routeAnimationLeft_factory(view, element, currentState, nextState) {
    var previousPlayers = view.animationContext.getAnimationPlayers(element, ((nextState == 'void') ? null : 'routeAnimationLeft'));
    var collectedStyles = {};
    var player = null;
    var totalTime = 0;
    var defaultStateStyles = InstructionComponent_routeAnimationLeft_states['*'];
    var startStateStyles = InstructionComponent_routeAnimationLeft_states[currentState];
    if ((startStateStyles == null)) {
        (startStateStyles = defaultStateStyles);
    }
    var endStateStyles = InstructionComponent_routeAnimationLeft_states[nextState];
    if ((endStateStyles == null)) {
        (endStateStyles = defaultStateStyles);
    }
    if (((player == null) && ((currentState == 'void') && true))) {
        player = new import12.AnimationSequencePlayer([view.renderer.animate(element, new import13.AnimationStyles(import14.collectAndResolveStyles(collectedStyles, [
                startStateStyles,
                {
                    'opacity': '0',
                    'transform': 'translateX(-100%)'
                }
            ])), import14.balanceAnimationKeyframes(collectedStyles, endStateStyles, [
                new import15.AnimationKeyframe(0, new import13.AnimationStyles(import14.collectAndResolveStyles(collectedStyles, [{}]))),
                new import15.AnimationKeyframe(1, new import13.AnimationStyles(import14.collectAndResolveStyles(collectedStyles, [{}])))
            ]), 400, 0, 'ease-in', previousPlayers)]);
        totalTime = 400;
    }
    if (((player == null) && (true && (nextState == 'void')))) {
        player = new import12.AnimationSequencePlayer([view.renderer.animate(element, new import13.AnimationStyles(import14.collectAndResolveStyles(collectedStyles, [startStateStyles])), [
                new import15.AnimationKeyframe(0, new import13.AnimationStyles(import14.collectAndResolveStyles(collectedStyles, [{
                        'opacity': 'true',
                        'transform': 'true'
                    }
                ]))),
                new import15.AnimationKeyframe(1, new import13.AnimationStyles(import14.collectAndResolveStyles(collectedStyles, [{
                        'opacity': '0',
                        'transform': 'translateX(-100%)'
                    }
                ])))
            ], 400, 0, 'ease-out', previousPlayers)]);
        totalTime = 400;
    }
    if ((player == null)) {
        (player = new import16.NoOpAnimationPlayer());
    }
    player.onDone(function () {
        player.destroy();
        import14.renderStyles(element, view.renderer, import14.prepareFinalAnimationStyles(startStateStyles, endStateStyles));
    });
    new import12.AnimationSequencePlayer(previousPlayers).destroy();
    import14.renderStyles(element, view.renderer, import14.clearStyles(startStateStyles));
    view.animationContext.queueAnimation(element, 'routeAnimationLeft', player);
    return new import11.AnimationTransition(player, currentState, nextState, totalTime);
}
var renderType_InstructionComponent = import3.createRenderComponentType('', 0, import6.ViewEncapsulation.Emulated, styles_InstructionComponent, { 'routeAnimationLeft': InstructionComponent_routeAnimationLeft_factory });
var View_InstructionComponent0 = (function (_super) {
    __extends(View_InstructionComponent0, _super);
    function View_InstructionComponent0(viewUtils, parentView, parentIndex, parentElement) {
        return _super.call(this, View_InstructionComponent0, renderType_InstructionComponent, import7.ViewType.COMPONENT, viewUtils, parentView, parentIndex, parentElement, import8.ChangeDetectorStatus.CheckAlways) || this;
    }
    View_InstructionComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.parentElement);
        this._el_0 = import3.createRenderElement(this.renderer, parentRenderNode, 'section', new import3.InlineArray2(2, 'class', 'wrapper wrapper__introduction'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_2 = import3.createRenderElement(this.renderer, this._el_0, 'h2', import3.EMPTY_INLINE_ARRAY, null);
        this._text_3 = this.renderer.createText(this._el_2, 'Introduction', null);
        this._text_4 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_5 = import3.createRenderElement(this.renderer, this._el_0, 'p', new import3.InlineArray2(2, 'class', 'introduction__txt'), null);
        this._text_6 = this.renderer.createText(this._el_5, 'Genetic drift is a probabilistic process of allele recombination in the genotype. It acts to reduce a genetic variation.', null);
        this._text_7 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_8 = import3.createRenderElement(this.renderer, this._el_0, 'p', new import3.InlineArray2(2, 'class', 'introduction__txt'), null);
        this._text_9 = this.renderer.createText(this._el_8, 'The effect of a drift is proportional to the population size: the smaller population, the greater the drift effect.', null);
        this._text_10 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_11 = import3.createRenderElement(this.renderer, this._el_0, 'p', new import3.InlineArray2(2, 'class', 'introduction__txt'), null);
        this._text_12 = this.renderer.createText(this._el_11, 'The effective population size is a key concept - it is the size of an ideal (Wright-Fisher) \n            population that shows the same decay of the genetic variation as the actual population of interest.', null);
        this._text_13 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_14 = import3.createRenderElement(this.renderer, this._el_0, 'h2', import3.EMPTY_INLINE_ARRAY, null);
        this._text_15 = this.renderer.createText(this._el_14, 'Legend', null);
        this._text_16 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_17 = import3.createRenderElement(this.renderer, this._el_0, 'p', new import3.InlineArray2(2, 'class', 'introduction__txt'), null);
        this._text_18 = this.renderer.createText(this._el_17, 'If the inputted values are incorrect, the computing based on the last correct values!', null);
        this._text_19 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_20 = import3.createRenderElement(this.renderer, this._el_0, 'p', new import3.InlineArray2(2, 'class', 'introduction__txt'), null);
        this._text_21 = this.renderer.createText(this._el_20, 'Population - the number of people in the population, the number is rounded to integer for computing, the minimal value 2.', null);
        this._text_22 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_23 = import3.createRenderElement(this.renderer, this._el_0, 'p', new import3.InlineArray2(2, 'class', 'introduction__txt'), null);
        this._text_24 = this.renderer.createText(this._el_23, 'Generations - the number of generation, the number is rounded to integer for computing, the minimal value 1.', null);
        this._text_25 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_26 = import3.createRenderElement(this.renderer, this._el_0, 'p', new import3.InlineArray2(2, 'class', 'introduction__txt'), null);
        this._text_27 = this.renderer.createText(this._el_26, 'Simulations - the number of simulation, the number is rounded to integer for computing, the minimal value 1.', null);
        this._text_28 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_29 = import3.createRenderElement(this.renderer, this._el_0, 'p', new import3.InlineArray2(2, 'class', 'introduction__txt'), null);
        this._text_30 = this.renderer.createText(this._el_29, 'Init. Alleles Balance - the balance of alleles (A1A2) in the genotype, the value from 0 to 1.', null);
        this._text_31 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_32 = import3.createRenderElement(this.renderer, this._el_0, 'p', new import3.InlineArray2(2, 'class', 'introduction__txt'), null);
        this._text_33 = this.renderer.createText(this._el_32, 'Bottle Neck Probability (BNP) - the probability occurrence of events that strongly change the size of a population, \n            like migration, epidemics, wars etc. When BNP occur the population randomly decrease. The value from 0 to 1. \n            The number of population is limited to:', null);
        this._text_34 = this.renderer.createText(this._el_0, '\n            ', null);
        this._el_35 = import3.createRenderElement(this.renderer, this._el_0, 'span', import3.EMPTY_INLINE_ARRAY, null);
        this._text_36 = this.renderer.createText(this._el_35, ' (previous population) * (1 - (Natural decline * 2)) ', null);
        this._text_37 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_38 = import3.createRenderElement(this.renderer, this._el_0, 'p', new import3.InlineArray2(2, 'class', 'introduction__txt'), null);
        this._text_39 = this.renderer.createText(this._el_38, 'Natural decline - natural population decrease, the value from 0 to 1.', null);
        this._text_40 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_41 = import3.createRenderElement(this.renderer, this._el_0, 'p', new import3.InlineArray2(2, 'class', 'introduction__txt'), null);
        this._text_42 = this.renderer.createText(this._el_41, 'Natural growth - natural population increase, the value from 0 to 1.', null);
        this._text_43 = this.renderer.createText(this._el_0, '\n        ', null);
        this._el_44 = import3.createRenderElement(this.renderer, this._el_0, 'h4', import3.EMPTY_INLINE_ARRAY, null);
        this._text_45 = this.renderer.createText(this._el_44, 'Warning:', null);
        this._el_46 = import3.createRenderElement(this.renderer, this._el_0, 'span', import3.EMPTY_INLINE_ARRAY, null);
        this._text_47 = this.renderer.createText(this._el_46, 'Be careful inputting large values, they initiate a large amount of computation that can hang your browser!', null);
        this._text_48 = this.renderer.createText(this._el_0, '\n    ', null);
        this.init(null, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4,
            this._el_5,
            this._text_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._text_19,
            this._el_20,
            this._text_21,
            this._text_22,
            this._el_23,
            this._text_24,
            this._text_25,
            this._el_26,
            this._text_27,
            this._text_28,
            this._el_29,
            this._text_30,
            this._text_31,
            this._el_32,
            this._text_33,
            this._text_34,
            this._el_35,
            this._text_36,
            this._text_37,
            this._el_38,
            this._text_39,
            this._text_40,
            this._el_41,
            this._text_42,
            this._text_43,
            this._el_44,
            this._text_45,
            this._el_46,
            this._text_47,
            this._text_48
        ]), null);
        return null;
    };
    return View_InstructionComponent0;
}(import2.AppView));
export { View_InstructionComponent0 };
//# sourceMappingURL=instruction.component.ngfactory.js.map